import React, { useContext, useEffect, useState } from "react";
import DataTable from "examples/Tables/DataTable";
import PropTypes from "prop-types";
import MDBox from "components/MDBox";
import { LoginFormContext } from "context/LoginFormContext";
import { MODULES, SEARCH_INPUT_TYPES } from "helpers/constant";
import { amenityBookingList } from "Apis/amenity";
import moment from "moment";
import WbSunnyOutlinedIcon from "@mui/icons-material/WbSunnyOutlined";
import Brightness4OutlinedIcon from "@mui/icons-material/Brightness4Outlined";
import CalendarMonthOutlinedIcon from "@mui/icons-material/CalendarMonthOutlined";
import { Box, Chip, IconButton, Tooltip } from "@mui/material";
import { updateAmenityBookingList } from "Apis/amenity";
import { CheckCircle, Handshake, XCircle } from "lucide-react";
import Swal from "sweetalert2";
import { ContentCopy } from "@mui/icons-material";
import { occasionOption } from "Apis/occasion";
import SettleDepositForm from "./settleDeposit";
import BookingDetailModal from "./bookingDetalisModel";

const statusData = [
  { label: "Cancelled", value: "2" },
  { label: "Confirmed", value: "1" },
  { label: "Pending", value: "0" },
];
const customerStatusData = [
  { label: "Non Member", value: "1" },
  { label: "Member", value: "0" },
];
const cancelStatus = 2;
const confirmStatus = 1;

const paymentStatusData = [
  { label: "Pending", value: "0" },
  { label: "Success", value: "1" },
  { label: "Failed", value: "2" },
  // { label: "Success", value: "3" },
  { label: "Cancelled", value: "4" },
];

const BookingList = () => {
  const [occasionListData, setOccasionListData] = useState([]);
  const { modules, getModuleAccess, access, isLoading, setFilterLoader } =
    useContext(LoginFormContext);
  const { setNotification } = useContext(LoginFormContext);
  const [bookingListData, setBookingListData] = useState([]);
  const [rowCount, setRowCount] = useState(0);
  const [defaultFilter, setDefaultFilter] = useState({
    currentPage: 1,
    itemsPerPage: 10,
    sortBy: [{ id: "id", value: "desc" }],
  });
  const [filterVal, setFilterVal] = useState({ member_name: "" });
  const [detailOpen, setDetailOpen] = useState(false);
  const [detailRow, setDetailRow] = useState(null);
  const [settleDepositData, setSettleDepositData] = useState({});
  const [openSettleDeposit, setOpenSettleDeposit] = useState(false);
  const getOccasionListApi = async () => {
    const data = {
      is_admin: true,
    };
    let response = await occasionOption(data);

    if (response?.status === 200) {
      const sortedData = response.data.data.rows
        ?.map((item) => ({
          value: parseInt(item?.id),
          label: item?.name,
        }))
        ?.sort((a, b) => a?.label?.localeCompare(b.label));

      setOccasionListData(sortedData);
    }
  };
  useEffect(() => {
    getOccasionListApi();
  }, []);
  const handleOpenDetail = (row) => {
    setDetailRow(row);
    setDetailOpen(true);
  };
  const handleCloseDetail = () => {
    setDetailOpen(false);
    setDetailRow(null);
  };
  const handleFilter = (accessor, value) => {
    setFilterLoader(true);
    setFilterVal({ ...filterVal, [accessor]: value });
    setDefaultFilter((prev) => ({ ...prev, currentPage: 1 }));
  };

  const getOccasionList = async () => {
    const Obj = {
      ...defaultFilter,
      filters: {
        member_name: filterVal?.member_name,
        is_guest_customer: filterVal?.is_guest_customer?.value,
        transaction_status: filterVal?.transaction_status?.value,
        occasion_id: filterVal?.occasion?.value,
        status: filterVal?.status?.value,
      },
    };
    const response = await amenityBookingList(Obj);
    if (response?.status === 200) {
      setBookingListData(response?.data?.data?.rows);
      setRowCount(response?.data?.data?.count);
    }
  };

  useEffect(() => {
    getModuleAccess(MODULES.AMENITY);
  }, [modules]);

  useEffect(() => {
    getOccasionList();
  }, [filterVal, defaultFilter]);
  const getStatusLabel = (id) => {
    const status = statusData?.find((item) => item.value == id);
    return status ? status?.label : "-";
  };

  const handelStatusUpdate = async (rowId, statusId) => {
    const payload = {
      id: rowId,
      status: Number(statusId),
    };
    const response = await updateAmenityBookingList(payload);
    if (response?.status === 200) {
      getOccasionList();
      setNotification({
        color: "success",
        icon: "check",
        title: "Success",
        content: response?.data?.message,
        open: true,
      });
    } else {
      setNotification({
        color: "error",
        icon: "cancel",
        title: "Error",
        content: response?.data?.message,
        open: true,
      });
    }
  };
  const handleConfirmAction = (rowId, statusId) => {
    Swal.fire({
      title: "Confirm Booking?",
      text: "Are you sure you want to confirm this booking?",
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, Confirm",
      cancelButtonText: "No, Cancel",
    }).then((result) => {
      if (result.isConfirmed) {
        handelStatusUpdate(rowId, statusId);
      }
    });
  };

  const handleCancelAction = (rowId, statusId) => {
    Swal.fire({
      title: "Cancel Booking?",
      text: "Are you sure you want to cancel this booking? This action cannot be undone.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, Cancel it",
      cancelButtonText: "No, Keep it",
    }).then((result) => {
      if (result.isConfirmed) {
        handelStatusUpdate(rowId, statusId);
      }
    });
  };
  const handleSettle = (row) => {
    if (row) {
      setSettleDepositData(row);
      setOpenSettleDeposit(true);
    }
  };
  const data = {
    isFilter: true,
    columns: [
      {
        Header: "Name",
        accessor: "member_name",
        minWidth: "85px",
        sort: true,
        filterLabel: "Name",
        filterAccessor: "member_name",
        filterInputType: SEARCH_INPUT_TYPES.TEXT,
        filterHandleChange: handleFilter,
        Cell: ({ row }) => (
          <span
            style={{
              cursor: "pointer",
            }}
            onClick={() => handleOpenDetail(row?.original)}
          >
            {row?.original?.member_name || "-"}
          </span>
        ),
      },
      {
        Header: "Occasion",
        accessor: "occasion",
        minWidth: "85px",
        sort: false,
        filterLabel: "Occasion",
        filterAccessor: "occasion",
        filterInputType: SEARCH_INPUT_TYPES.AUTO_COMPLETE,
        filterHandleChange: handleFilter,
        filterOption: occasionListData,
        Cell: ({ value }) => (value ? <div>{value?.name}</div> : "-"),
      },

      {
        Header: "Slot",
        accessor: "slot",
        minWidth: "120px",
        sort: false,
        Cell: ({ value }) => {
          const isMorning = Number(value) === 1;

          return value ? (
            <Chip
              icon={
                isMorning ? (
                  <WbSunnyOutlinedIcon fontSize="small" />
                ) : (
                  <Brightness4OutlinedIcon fontSize="small" />
                )
              }
              label={isMorning ? "Morning" : "Evening"}
              size="small"
              sx={{
                fontWeight: 600,
                borderRadius: "8px",
                ...(isMorning
                  ? {
                      bgcolor: "#FFF8E1",
                      color: "#F57C00",
                      "& .MuiChip-icon": {
                        color: "#F57C00",
                      },
                    }
                  : {
                      bgcolor: "#E3F2FD",
                      color: "#1565C0",
                      "& .MuiChip-icon": {
                        color: "#1565C0",
                      },
                    }),
              }}
            />
          ) : (
            "-"
          );
        },
      },
      {
        Header: "Booking Dates",
        accessor: "amenity_booking_slots",
        sort: false,
        Cell: ({ row }) => {
          const bookingDates = row?.original?.amenity_booking_slots || [];

          return (
            <Box
              sx={{
                display: "flex",
                flexWrap: "wrap",
                gap: 0.75,
                minWidth: 250,
                maxWidth: 350,
              }}
            >
              {bookingDates?.length > 0
                ? bookingDates?.map((item) => (
                    <Box
                      key={item?.id}
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 0.5,
                        px: 1.25,
                        py: 0.6,
                        borderRadius: "999px",
                        bgcolor: "primary.lighter",
                        color: "primary.main",
                        border: (theme) => `1px solid ${theme.palette.primary.light}`,
                        fontSize: "14px",
                        fontWeight: 600,
                        lineHeight: 1,
                        whiteSpace: "nowrap",
                      }}
                    >
                      <CalendarMonthOutlinedIcon
                        sx={{
                          fontSize: 18,
                        }}
                      />
                      {moment(item?.booking_date).format("DD MMM")}
                    </Box>
                  ))
                : "-"}
            </Box>
          );
        },
      },
      // {
      //   Header: "Booking Slot",
      //   accessor: "slot",
      //   sort: false,
      //   Cell: ({ value }) => (
      //     <DefaultCell
      //       value={
      //         value === 1 ? (
      //           <Chip
      //             label="Morning"
      //             size="small"
      //             variant="outlined"
      //             sx={{ marginBottom: "4px", padding: "4px 8px" }}
      //           />
      //         ) : (
      //           <Chip
      //             label="Evening"
      //             size="small"
      //             variant="outlined"
      //             sx={{ marginBottom: "4px", padding: "4px 8px" }}
      //           />
      //         )
      //       }
      //     />
      //   ),
      // },
      {
        Header: "Customer Type",
        accessor: "is_guest_customer",
        minWidth: "85px",
        sort: false,
        filterLabel: "Customer Type",
        filterAccessor: "is_guest_customer",
        filterInputType: SEARCH_INPUT_TYPES.AUTO_COMPLETE,
        filterHandleChange: handleFilter,
        filterOption: customerStatusData,
        Cell: ({ value }) => <p>{value === 0 ? "Member" : "Non Member"}</p>,
      },
      // {
      //   Header: "Amenity",
      //   accessor: "amenity_booking_orders",
      //   minWidth: "85px",
      //   sort: false,
      //   Cell: ({ value }) =>
      //     value?.length ? (
      //       <Stack direction="row" spacing={1} maxWidth={300} flexWrap="wrap" useFlexGap>
      //         {value.map((item, index) => (
      //           <Chip
      //             key={index}
      //             label={item?.amenity?.name}
      //             size="small"
      //             variant="outlined"
      //             sx={{ marginBottom: "4px", padding: "4px 8px" }}
      //           />
      //         ))}
      //       </Stack>
      //     ) : (
      //       "-"
      //     ),
      // },
      {
        Header: "Total Amount",
        accessor: "total_amount",
        minWidth: "85px",
        sort: true,
        Cell: ({ value }) => <span>{value ? `₹${value}` : "₹0"}</span>,
      },
      {
        Header: "Payment Link",
        accessor: "order_transactions",
        maxWidth: "85px",
        sort: false,
        Cell: ({ value }) => {
          const paymentLink = value?.[0]?.payment_link;

          const handleCopy = async () => {
            if (!paymentLink) return;

            try {
              await navigator?.clipboard?.writeText(paymentLink);
              // toast.success("Payment link copied!");
              setNotification({
                color: "success",
                icon: "check",
                title: "Success",
                content: "Payment link copied!",
                open: true,
              });
            } catch (error) {
              // toast.error("Failed to copy link");
              setNotification({
                color: "error",
                icon: "check",
                title: "Error",
                content: "Failed to copy link",
                open: true,
              });
            }
          };

          return paymentLink ? (
            <MDBox display="flex" alignItems="flex-start" gap={1}>
              <a
                href={paymentLink}
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  display: "block",
                  width: "180px",
                  wordBreak: "break-all",
                  whiteSpace: "normal",
                  color: "#2563eb",
                  textDecoration: "underline",
                }}
              >
                {paymentLink}
              </a>

              <Tooltip title="Copy Link">
                <IconButton size="small" onClick={handleCopy}>
                  <ContentCopy fontSize="small" />
                </IconButton>
              </Tooltip>
            </MDBox>
          ) : (
            "-"
          );
        },
      },
      // {
      //   Header: "Booking Status",
      //   accessor: "status",
      //   sort: false,
      //   filterLabel: "Status",
      //   filterAccessor: "status",
      //   filterInputType: SEARCH_INPUT_TYPES.AUTO_COMPLETE,
      //   filterHandleChange: handleFilter,
      //   filterOption: statusData,
      //   Cell: ({ row }) => (
      //     <Chip
      //       label={
      //         row.original.status === 2
      //           ? "Cancel"
      //           : row.original.status === 1
      //             ? "Confirmed"
      //             : "Pending"
      //       }
      //       size="small"
      //       color={
      //         row.original.status === 2
      //           ? "error"
      //           : row.original.status === 1
      //             ? "success"
      //             : "warning"
      //       }
      //       variant="outlined"
      //       // onClick={() => handleOpenModal(row.original)}
      //       sx={{ padding: "4px 8px" }}
      //     />
      //   ),
      // },
      {
        Header: "Booking Status",
        accessor: "status",
        minWidth: "100px",
        filterLabel: "Status",
        filterAccessor: "status",
        filterInputType: SEARCH_INPUT_TYPES.AUTO_COMPLETE,
        filterHandleChange: handleFilter,
        filterOption: statusData,

        Cell: ({ value }) => {
          const getStatusLabel = (statusValue) => {
            switch (statusValue) {
              case 1:
              case "1":
                return "Confirmed";

              case 0:
              case "0":
                return "Pending";

              case 2:
              case "2":
                return "Cancelled";

              default:
                return "-";
            }
          };

          const getStatusStyle = (statusValue) => {
            switch (statusValue) {
              case 1:
              case "1":
                return {
                  backgroundColor: "#e8f5e8",
                  color: "#155724",
                };

              case 0:
              case "0":
                return {
                  backgroundColor: "#fff3cd",
                  color: "#856404",
                };

              case 2:
              case "2":
                return {
                  backgroundColor: "#f8d7da",
                  color: "#721c24",
                };

              default:
                return {
                  backgroundColor: "#f8f9fa",
                  color: "#495057",
                };
            }
          };

          return (
            <MDBox
              sx={{
                display: "inline-block",
                padding: "4px 8px",
                borderRadius: "4px",
                fontSize: "12px",
                fontWeight: "bold",
                textTransform: "capitalize",
                ...getStatusStyle(value),
              }}
            >
              {getStatusLabel(value)}
            </MDBox>
          );
        },
      },
      {
        Header: "Payment Status",
        accessor: "transaction_status",
        sort: false,
        minWidth: "120px",
        filterLabel: "Payment Status",
        filterAccessor: "transaction_status",
        filterInputType: SEARCH_INPUT_TYPES.AUTO_COMPLETE,
        filterHandleChange: handleFilter,
        filterOption: paymentStatusData,

        Cell: ({ row }) => {
          const value = row?.original?.order_transactions?.[0]?.transaction_status;

          const getStatusLabel = (statusValue) => {
            switch (statusValue) {
              case 0:
              case "0":
                return "Pending";

              case 1:
              case "1":
                return "Success";

              case 2:
              case "2":
                return "Failed";

              case 3:
              case "3":
                return "Success";

              case 4:
              case "4":
                return "Cancelled";

              default:
                return "-";
            }
          };

          const getStatusStyle = (statusValue) => {
            switch (statusValue) {
              case 0:
              case "0":
                return {
                  backgroundColor: "#fff3cd",
                  color: "#856404",
                };

              case 1:
              case "1":
                return {
                  backgroundColor: "#e8f5e8",
                  color: "#155724",
                };

              case 2:
              case "2":
                return {
                  backgroundColor: "#f8d7da",
                  color: "#721c24",
                };

              case 3:
              case "3":
                return {
                  backgroundColor: "#e8f5e8",
                  color: "#155724",
                };

              case 4:
              case "4":
                return {
                  backgroundColor: "#f8d7da",
                  color: "#721c24",
                };

              default:
                return {
                  backgroundColor: "#f8f9fa",
                  color: "#495057",
                };
            }
          };

          return (
            <MDBox
              sx={{
                display: "inline-block",
                padding: "4px 8px",
                borderRadius: "4px",
                fontSize: "12px",
                fontWeight: "bold",
                textTransform: "capitalize",
                ...getStatusStyle(value),
              }}
            >
              {getStatusLabel(value)}
            </MDBox>
          );
        },
      },
      // {
      //   Header: "Deposit Settled Status",
      //   accessor: "is_settled",
      //   minWidth: "85px",
      //   sort: true,
      //   Cell: ({ value, row }) =>
      //     value === 1 ? (
      //       <span
      //         style={{
      //           display: "inline-flex",
      //           alignItems: "center",
      //           gap: "5px",
      //           background: "var(--color-background-success, #eaf3de)",
      //           color: "var(--color-text-success, #3b6d11)",
      //           border: "0.5px solid var(--color-border-success, #639922)",
      //           borderRadius: "999px",
      //           fontSize: "12px",
      //           fontWeight: 500,
      //           padding: "3px 10px",
      //           whiteSpace: "nowrap",
      //         }}
      //       >
      //         <CheckCircle2 size={13} />
      //         Settled
      //       </span>
      //     ) : (
      //       <button
      //         onClick={() => handleSettle(row)}
      //         style={{
      //           display: "inline-flex",
      //           alignItems: "center",
      //           gap: "5px",
      //           background: "transparent",
      //           color: "var(--color-text-danger, #a32d2d)",
      //           border: "0.5px solid var(--color-border-danger, #e24b4a)",
      //           borderRadius: "8px",
      //           fontSize: "12px",
      //           fontWeight: 500,
      //           padding: "4px 10px",
      //           cursor: "pointer",
      //           whiteSpace: "nowrap",
      //         }}
      //       >
      //         <AlertCircle size={13} />
      //         Settle now
      //       </button>
      //     ),
      // },
      {
        Header: "Action",
        accessor: "action",
        sort: false,
        Cell: ({ row }) => (
          <Box sx={{ display: "flex", gap: 2, alignItems: "center" }}>
            {/* {row?.original?.is_settled === 0 && row?.original?.status === 1 && (
              <Tooltip title="Settlement Amount">
                <IconButton
                  size="small"
                  onClick={() => handleSettle(row)}
                  sx={{
                    color: "#3b9a4c",
                    backgroundColor: "#3b9a4c15",
                    borderRadius: "6px",
                    padding: "10px",
                    "&:hover": {
                      backgroundColor: "#3b9a4c25",
                    },
                  }}
                >
                  <Handshake size={20} />
                </IconButton>
              </Tooltip>
            )} */}
            {row?.original?.status === 0 && access?.write_access && (
              <Tooltip title="Confirm">
                <IconButton
                  size="small"
                  onClick={() => handleConfirmAction(row?.original?.id, confirmStatus)}
                  sx={{
                    color: "#3b9a4c",
                    backgroundColor: "#3b9a4c15",
                    borderRadius: "6px",
                    padding: "10px",
                    "&:hover": {
                      backgroundColor: "#3b9a4c25",
                    },
                  }}
                >
                  <CheckCircle size={20} />
                </IconButton>
              </Tooltip>
            )}
            {access?.write_access &&
              (row?.original?.status === 0 || row?.original?.status === 1) && (
                <Tooltip title="Cancel">
                  <IconButton
                    size="small"
                    onClick={() => handleCancelAction(row?.original?.id, cancelStatus)}
                    sx={{
                      color: "#9A3B3B",
                      backgroundColor: "#9A3B3B15",
                      borderRadius: "6px",
                      padding: "10px",
                      "&:hover": {
                        backgroundColor: "#9A3B3B25",
                      },
                    }}
                  >
                    <XCircle size={20} />
                  </IconButton>
                </Tooltip>
              )}
          </Box>
        ),
      },
    ],
    rows: bookingListData,
  };

  return (
    !isLoading && (
      <>
        <BookingDetailModal
          detailOpen={detailOpen}
          handleCloseDetail={handleCloseDetail}
          detailRow={detailRow}
          getStatusLabel={getStatusLabel}
        />

        <MDBox sx={{ marginTop: "30px" }}>
          <DataTable
            table={data}
            isSorted={false}
            entriesPerPage={true}
            showTotalEntries={true}
            noEndBorder
            canFilter
            canSearch={true}
            tableTitle="Booking List"
            updateApi={() => {}}
            getDataList={getOccasionList}
            rowCount={rowCount}
            defaultFilter={defaultFilter}
            setDefaultFilter={setDefaultFilter}
          />
        </MDBox>
        <SettleDepositForm
          open={openSettleDeposit}
          setOpen={setOpenSettleDeposit}
          settleDepositData={settleDepositData}
          setSettleDepositData={setSettleDepositData}
          getOccasionList={getOccasionList}
        />
      </>
    )
  );
};

BookingList.propTypes = {
  value: PropTypes.string,
  row: PropTypes.object,
};

export default BookingList;
